import React from "react";

const NoMatchRoute = () => <div>NO FOUNDED PAGE</div>;

export default NoMatchRoute;
